import Vue from "vue";
import Vuex from "vuex";
//import axios from "axios";
import errors from "@/services/errors";

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    results: [],
    pagination: null,
    statusId: 100,
    orderBy: null,
    search: null,
    page: 0,
    pageSize: 10,
    totalResults: null,
    listUpdated: false
  },
  mutations: {
    SET_RESULTS(state, payload) {
      state.results = payload.results;
      if (payload.pagination) {
        state.pagination = payload.pagination;
        state.page = payload.pagination.page;
        state.pageSize = payload.pagination.pageSize;
        state.totalResults = payload.pagination.totalResults;
      } else {
        state.pagination = null;
        state.page = 0;
        state.totalResults = null;
      }
    },
    SET_STATUS_ID(state, payload) {
      state.statusId = payload;
    },
    SET_ORDER_BY(state, payload) {
      state.orderBy = payload;
    },
    SET_SEARCH(state, payload) {
      state.search = payload;
    },
    SET_PAGE(state, payload) {
      state.page = payload;
    },
    SET_RESET_PAGE(state, payload) {
      state.page = 0;
    },
    SET_PAGE_SIZE(state, payload) {
      state.pageSize = payload;
      state.page = 1; //reset page on page size change
    },
    SET_RESET_DATA(state, payload) {
      state.results = [];
      state.pagination = null;
      state.page = 0;
      state.pageSize = 25;
      state.totalResults = null;
      state.statusId = 100;
      state.orderBy = null;
      state.search = null;
    },
    SET_LIST_UPDATED(state, payload) {
      state.listUpdated = payload;
    }
  },
  actions: {
    //PRE: you can send payload.params to override and set params
    //     at call time. Otherwise it uses the params previously set.
    async load({ commit }, payload) {
      try {
        const order = this.state.subscribers.orderBy;
        //console.log("userStore: user data stored");
        const res = await Vue.prototype.$axios.get(
          `/subscriptions/${payload.subscriptionId}/subscribers`,
          {
            params: {
              statusId: this.state.subscribers.statusId || "",
              orderBy: this.state.subscribers.orderBy || "",
              page: this.state.subscribers.page + 1,
              pageSize: this.state.subscribers.pageSize,
              search: this.state.subscribers.search || ""
            }
          }
        );
        if (res.status != 200) throw errors.handleHTTPError(res);
        //if (res.data.results.length > 0) {
        commit("SET_RESULTS", res.data);
        //}
      } catch (error) {
        throw error;
      }
    },
    async loadOne({ commit }, id) {
      try {
        //console.log("userStore: user data stored");
        const res = await Vue.prototype.$axios.get(`/subscriptions/${id}`);
        if (res.status != 200) throw errors.handleHTTPError(res);
        commit("SET_SUBSCRIPTION_DETAILS", res.data);
      } catch (error) {
        throw error;
      }
    },
    async unsubscribe({ commit }, payload) {
      try {
        const unsubscribeRes = await Vue.prototype.$axios.delete(
          `/subscriptions/${payload.subscriptionId}/subscribers/${payload.subscriberId}`
        );
        if (unsubscribeRes.status != 200)
          throw errors.handleHTTPError(
            unsubscribeRes,
            "Error: No se pudo desuscribir al cliente."
          );
        else return unsubscribeRes.data.message;
      } catch (error) {
        throw error;
      }
    },
    async activate({ commit }, payload) {
      try {
        const activateRes = await Vue.prototype.$axios.post(
          `/subscriptions/${payload.subscriptionId}/subscribers/${payload.subscriberId}/activate`
        );
        if (activateRes.status != 201)
          throw errors.handleHTTPError(
            activateRes,
            "Hubo un error al intentar reactivar al cliente."
          );
        else return "Se reactivo la suscripción del cliente.";
      } catch (error) {
        throw error;
      }
    }
    /*
    async save({ commit }, params) {
      try {
        //console.log("userStore: user data stored");
        let res = await Vue.prototype.$axios.put(
          `/subscriptions/${params.id}`,
          {
            name: params.name,
            amount: params.amount,
            frequencyId: params.frequencyId,
            endDate: params.endDate,
            freeTrialDays: params.freeTrialDays,
            costCenterId: params.costCenterId,
            businessUnitId: params.businessUnitId,
            status: params.status
          }
        );
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    async add({ commit }, params) {
      try {
        //console.log("userStore: user data stored");
        let res = await Vue.prototype.$axios.post("/subscriptions", {
          name: params.name,
          amount: params.amount,
          frequencyId: params.frequencyId,
          endDate: params.endDate,
          freeTrialDays: params.freeTrialDays,
          costCenterId: params.costCenterId,
          businessUnitId: params.businessUnitId
        });
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    async delete({ commit }, id) {
      try {
        //console.log("userStore: user data stored");
        let res = await Vue.prototype.$axios.delete(`/subscriptions/${id}`);
      } catch (error) {
        console.log(error);
        throw error;
      }
    }*/
  },
  getters: {
    subscribers: state => {
      const subscribers = {
        results: state.results,
        pagination: state.pagination,
        statusId: state.statusId,
        orderBy: state.orderBy,
        search: state.search,
        page: state.page,
        pageSize: state.pageSize
      };
      return subscribers;
    },
    listUpdated: state => {
      return state.listUpdated;
    }
  }
};
